/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { divideDependencies } from './dependenciesDivide.generated';
import { dotDivideDependencies } from './dependenciesDotDivide.generated';
import { isNumericDependencies } from './dependenciesIsNumeric.generated';
import { logDependencies } from './dependenciesLog.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { sumDependencies } from './dependenciesSum.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createKldivergence } from '../../factoriesAny.js';
export var kldivergenceDependencies = {
  divideDependencies: divideDependencies,
  dotDivideDependencies: dotDivideDependencies,
  isNumericDependencies: isNumericDependencies,
  logDependencies: logDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  sumDependencies: sumDependencies,
  typedDependencies: typedDependencies,
  createKldivergence: createKldivergence
};